const range = (start: number, end: number, step: number) =>
  Array.from({ length: Math.ceil((end - start) / step) }, (_, i) => start + i * step);

export interface IGenerateRange {
  /**
   * Starting point of the range (inclusive, default: 0).
   */
  start?: number;
  /**
   * Stopping point of the range (exclusive).
   */
  stop: number;
  /**
   * Interval between values in the range (default: 1).
   */
  step?: number;
  /**
   * When true, yield values from the range in a loop forever-and-ever.
   */
  cycle?: boolean;
}

/**
 * Return a generator yielding a sequence of numbers from [start, maximum).
 *
 * @param {IGenerateRange}  - options
 *
 * @returns {Generator<number>} - delaySeconds
 *
 */
export function* generateRange({
  start = 0,
  stop,
  step = 1,
  cycle = false,
}: IGenerateRange): Generator<number> {
  const values: number[] = range(start, stop, step);

  if (values.length < 1) {
    // short circuit if there are no values in the range
    return;
  }

  while (true) {
    for (const value of values) {
      yield value;
    }
    if (!cycle) {
      return;
    }
  }
}
